import * as APSExternals from './externals';

export const DOMAIN_NAME = 'aps';

export const APSActions = Object.freeze({
  ADD_ITEM_FEEDBACK: 'ADD_ITEM_FEEDBACK',
  ITEM_ENDED: 'ITEM_ENDED',
  PAUSE_SOURCE: 'PAUSE_SOURCE',
  PLAY_CURRENT_ITEM_FOR_SOURCE: 'PLAY_CURRENT_ITEM_FOR_SOURCE',
  PLAY_SOURCE: 'PLAY_SOURCE',
  REMOVE_ITEM_FEEDBACK: 'REMOVE_ITEM_FEEDBACK',
  REPEAT_SOURCE: 'REPEAT_SOURCE',
  REPLAY_ITEM: 'REPLAY_ITEM',
  RESET_APS: 'RESET_APS',
  RESET_CURRENT_SOURCE: 'RESET_CURRENT_SOURCE',
  RESUME_SOURCE: 'RESUME_SOURCE',
  SET_CURRENT_ITEM: 'SET_CURRENT_ITEM',
  SHUFFLE_SOURCE: 'SHUFFLE_SOURCE',
  SKIP_ITEM: 'SKIP_ITEM',
  ...APSExternals.APSActions,
} as const);

export const APSErrorCodes = Object.freeze({
  FLEX_REPLAY_LISTENER_INELIGIBLE: 'FLEX_REPLAY_LISTENER_INELIGIBLE',
  INDEX_OUT_OF_BOUNDS: 'INDEX_OUT_OF_BOUNDS',
  INVALID_REQUEST: 'INVALID_REQUEST',
  INVALID_SOURCE: 'INVALID_SOURCE',
  MIDROLL_NOT_SUPPORTED: 'MIDROLL_NOT_SUPPORTED',
  NO_CLEAN_CONTENT: 'NO_CLEAN_CONTENT',
  NO_ENTITLEMENTS: 'NO_ENTITLEMENTS',
  NO_PLAYABLE_CONTENT: 'NO_PLAYABLE_CONTENT',
  NOT_SUPPORTED: 'NOT_SUPPORTED',
  PARAMETER_VALUE_INVALID: 'PARAMETER_VALUE_INVALID',
  READONLY_MODE: 'READONLY_MODE',
  SERVER_ERROR: 'SERVER_ERROR',
  SKIP_LIMIT_REACHED: 'SKIP_LIMIT_REACHED',
  SOURCE_ENDED: 'SOURCE_ENDED',
  SOURCE_NOT_SET: 'SOURCE_NOT_SET',
  STATION_LIMIT_REACHED: 'STATION_LIMIT_REACHED',
  STREAM_INACTIVE: 'STREAM_INACTIVE',
} as const);

export const APSItemTypes = Object.freeze({
  SimStreamViolation: 'SimStreamViolation',
  IdleTimeout: 'IdleTimeout',
  PremiumAccessEnd: 'PremiumAccessEnd',
  VoiceTrack: 'VoiceTrack',
} as const);

export const APSKeys = Object.freeze({
  CURRENT_ITEM: 'currentItem',
  LYRIC_DATA: 'lyricData',
  NARRATIVE: 'narrative',
  NEXT_ITEM: 'nextItem',
  RATING: 'rating',
  SESSION_ITEMS: APSExternals.APSKeys.SESSION_ITEMS,
  SESSION_LIST: 'sessionList',
  SOURCE: 'source',
} as const);

export const APSTrackEndReasons = Object.freeze({
  ERROR: APSExternals.APSTrackEndReasons.ERROR,
  NORMAL: 'NORMAL',
} as const);
